import React from 'react';

import './modal.css';
import ReactDOM from 'react-dom';

export default class Modal extends React.Component {

    constructor() {
        super();

        this.listenKeyboard = this.listenKeyboard.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
    }

    componentDidMount() {
        if (this.props.onClose) {
            window.addEventListener('keydown', this.listenKeyboard, true);
        }
    }

    componentWillUnmount() {
        if (this.props.onClose) {
            window.removeEventListener('keydown', this.listenKeyboard, true);
        }
    }

    listenKeyboard(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            this.props.onClose();
        }
    }

    onOverlayClick(event) {
        this.props.onClose();
        event.stopPropagation();
    }

    static onDialogClick(event) {
        event.stopPropagation();
    }

    render() {
        const {
            show = false,
            overlayStyle = {},
            contentStyle = {},
            dialogStyle = {},
            children,
        } = this.props;

        if (!show) {
            return null;
        }

        return ReactDOM.createPortal(
            (<div>
                <div className='modal-overlay-div' style={overlayStyle}/>
                <div className='modal-content-div' style={contentStyle} onClick={this.onOverlayClick}>
                    <div className='modal-dialog-div' style={dialogStyle} onClick={Modal.onDialogClick}>
                        {children}
                    </div>
                </div>
            </div>),
            document.getElementById('root')
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/modal.js